<template>
  <div
    class="ad-mouse-3d"
    @mousemove="onMove"
    @mouseleave="onLeave"
  >
    <div class="ad-mouse-3d__tilt" :style="tiltStyle">
      <div class="ad-mouse-3d__lift">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdBannerMouse3d',
  data() {
    return {
      rx: 0,
      ry: 0,
      tx: 0,
      ty: 0,
      active: false,
      rafId: null,
      reduceMotion: false,
    };
  },
  computed: {
    tiltStyle() {
      if (this.reduceMotion) {
        return { transform: 'none', transformStyle: 'flat' };
      }
      return {
        transform: `rotateX(${this.rx}deg) rotateY(${this.ry}deg)`,
        transformStyle: 'preserve-3d',
      };
    },
  },
  mounted() {
    if (typeof window !== 'undefined' && window.matchMedia) {
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }
  },
  created() {
    this.step = this.step.bind(this);
  },
  beforeUnmount() {
    if (this.rafId) cancelAnimationFrame(this.rafId);
  },
  methods: {
    onMove(e) {
      const el = this.$el;
      if (!el || el.clientWidth === 0) return;
      this.active = true;
      const r = el.getBoundingClientRect();
      const px = (e.clientX - r.left) / r.width;
      const py = (e.clientY - r.top) / r.height;
      this.tx = (px - 0.5) * 22;
      this.ty = (py - 0.5) * -15;
      if (!this.rafId) this.rafId = requestAnimationFrame(this.step);
    },
    onLeave() {
      this.active = false;
      this.tx = 0;
      this.ty = 0;
      if (!this.rafId) this.rafId = requestAnimationFrame(this.step);
    },
    step() {
      this.rafId = null;
      const k = 0.11;
      this.rx += (this.ty - this.rx) * k;
      this.ry += (this.tx - this.ry) * k;
      const done =
        !this.active &&
        Math.abs(this.rx) < 0.04 &&
        Math.abs(this.ry) < 0.04;
      if (!done) {
        this.rafId = requestAnimationFrame(this.step);
      }
    },
  },
};
</script>

<style scoped>
.ad-mouse-3d {
  perspective: 1400px;
  perspective-origin: 50% 50%;
}

.ad-mouse-3d__tilt {
  transform-style: preserve-3d;
  will-change: transform;
}

.ad-mouse-3d__lift {
  transform: translateZ(26px);
  transform-style: preserve-3d;
}

@media (prefers-reduced-motion: reduce) {
  .ad-mouse-3d__tilt {
    transform: none !important;
  }

  .ad-mouse-3d__lift {
    transform: none;
  }
}
</style>